<h1 mat-dialog-title>{{ 'PAYMENTS_POPUP.TITLE' | translate }}</h1>

<form [formGroup]="paymentFormGroup" (ngSubmit)="submit()" class="payment-popup">

  <section mat-dialog-content>

    <app-async-selector class="payment-popup__form-field"
                        [options]="paymentOptions$"
                        viewValue="value"
                        value="id"
                        [label]="'PAYMENT.METHODS_PLACEHOLDER' | translate"
                        formControlName="method"
                        [required]="true"
    ></app-async-selector>

    <mat-form-field class="payment-popup__form-field">
      <mat-label>{{ 'PAYMENTS_FORM.AMOUNT_LABEL' | translate }}</mat-label>
      <input matInput type="number"
             [min]="minValue"
             formControlName="amount"
             required>
      <mat-hint>{{ 'FROM' | translate }} {{ minValue }} {{ 'CURRENCY' | translate }}</mat-hint>
    </mat-form-field>
  </section>

  <section mat-dialog-actions align="end">
    <button mat-button type="button" matDialogClose>{{ 'BUTTONS.cancel' | translate }}</button>
    <button mat-button color="primary" type="submit">{{ 'BUTTONS.continue' | translate }}</button>
  </section>

</form>
